import {announceFromElement} from '@github-ui/aria-live'
import {observe} from '@github-ui/selector-observer'

const stopAnnouncingByDiscussion = new WeakMap<Element, () => void>()

// Scoped to one discussion and torn down on removal so observers don't pile up across soft navigations.
function announceNewTimelineItems(discussion: Element): () => void {
  let existingTimelineItems: WeakSet<Element> = new WeakSet()
  setExistingTimelineItems()

  const controller = new AbortController()
  document.addEventListener('turbo:load', setExistingTimelineItems, {signal: controller.signal})

  const timelineItemObserver = observe('.js-timeline-item', el => {
    if (!(el instanceof HTMLElement)) return
    if (!discussion.contains(el)) return
    if (existingTimelineItems.has(el)) return

    announceFromElement(el)
  })

  function setExistingTimelineItems() {
    existingTimelineItems = new WeakSet(document.querySelectorAll('.js-timeline-item'))
  }

  return () => {
    controller.abort()
    timelineItemObserver.abort()
  }
}

observe('.js-discussion', {
  add(discussion) {
    stopAnnouncingByDiscussion.get(discussion)?.()
    stopAnnouncingByDiscussion.set(discussion, announceNewTimelineItems(discussion))
  },
  remove(discussion) {
    stopAnnouncingByDiscussion.get(discussion)?.()
    stopAnnouncingByDiscussion.delete(discussion)
  },
})
